const PQueue = require('p-queue');

class GraphQLConnector {
  constructor() {
    this.dataLoadedEventKey = 'dataLoaded';
  }

  init() {
    this.pq = new PQueue({
      concurrency: 2,
    });
  }

  loadData(query) {

    const requestHeaders = new Headers();
    requestHeaders.append('Content-Type', 'application/json');
    // requestHeaders.append('Authorization', 'Basic c2ltcGxlOmxvY2s=   ');

    return this.pq.add(() => {

      /* eslint-disable */
      const queryObject = {
        "query": query,
        "variables": null,
        "operationName": null
      };

      return new Promise((resolve, reject) => {
        fetch('https://bfv-apiwrapper.oc.diva-e.com/graphql/?', {
          method: 'POST',
          body: JSON.stringify(queryObject),
          headers: requestHeaders,
        })
          .then(response => response.json())
          .then((jsonResponse) => {
            setTimeout(() => {
              resolve(jsonResponse.data);
            }, 2000);
          })
          .catch((error) => {
            console.info('Error occurred');
            console.error(error);
            reject(error);
          });
      })
        .catch((error) => {
          console.info('Error occurred');
          console.error(error);
          return;
        });
    });
  }
}

export default GraphQLConnector;



// WEBPACK FOOTER //
// ./src/javascript/graphql/index.js